<template>
  <tr>
    <td >{{user.name}}</td>
    <td >{{user.last_name}}</td>
    <td >{{user.username}}</td>
    <td >{{user.perfil}}</td>    
    <td >{{user.email}}</td>
    <td >{{user.tel}}</td>
    <td>
      <div class="container">
        <button type="button" class="btn btn-warning" @click="seleccionar">edit</button>        
      </div>
    </td>
  </tr>
</template>
<script>
export default {
  name: "User",
  props: {    
    user: {
      user_id: Number,
      name: String,
      username: String,
      last_name: String,
      email: String,
      tel: Number
    }
  },  
  methods: {
    seleccionar() {      
      this.$store.dispatch('selectUserAction', this.user);
      this.$bvModal.show('my-user-modal')   
    },      
  }
};
</script>
<style>
</style>